export const perferenceOptions = [
  { label: 'Select', value: '' },
  { label: 'Full-time', value: 'full-time' },
  { label: 'Part-time', value: 'part-time' }
];
